import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[appAutoFocus]',
    standalone: false
})
export class AutoFocusDirective {
  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.elementRef.nativeElement.focus();
    this.elementRef.nativeElement.scrollIntoView();
  }
}
